import React from 'react';
import {
  View,
  Text,
  StyleSheet,
} from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

interface PaymentDetailsSummaryProps {
  paymentAmount: number;
  fee: number;
  totalAmount: number;
  paymentMethodLabel: string;
  residentName?: string;
  containerStyle?: object;
}

/**
 * Reusable payment details summary component
 * Used in ConfirmPaymentContent and TransactionReceivedContent
 */
export const PaymentDetailsSummary: React.FC<PaymentDetailsSummaryProps> = ({
  paymentAmount,
  fee,
  totalAmount,
  paymentMethodLabel,
  residentName,
  containerStyle,
}) => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <View style={[styles.detailsContainer, containerStyle]}>
      {/* Payment on behalf of */}
      <View style={styles.detailRow}>
        <Text style={[styles.detailLabel, { color: MARKETPLACE_COLORS.textPrimary }]}>Payment on behalf of</Text>
        <Text style={[styles.detailValue, { color: MARKETPLACE_COLORS.textPrimary }]}>{residentName || 'Yourself'}</Text>
      </View>

      {/* Payment amount */}
      <View style={styles.detailRow}>
        <Text style={[styles.detailLabel, { color: MARKETPLACE_COLORS.textPrimary }]}>Payment amount</Text>
        <Text style={[styles.detailValue, { color: MARKETPLACE_COLORS.textPrimary }]}>{paymentAmount.toFixed(2)}</Text>
      </View>

      {/* Fee */}
      <View style={styles.detailRow}>
        <Text style={[styles.detailLabel, { color: MARKETPLACE_COLORS.textPrimary }]}>Fee</Text>
        <Text style={[styles.detailValue, { color: MARKETPLACE_COLORS.textPrimary }]}>{fee.toFixed(2)}</Text>
      </View>

      {/* Total */}
      <View style={styles.totalRow}>
        <Text style={[styles.totalLabel, { color: MARKETPLACE_COLORS.textPrimary }]}>
          Total charges to {paymentMethodLabel}
        </Text>
        <Text style={[styles.totalValue, { color: MARKETPLACE_COLORS.textPrimary }]}>
          $ {totalAmount.toFixed(2)}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  detailsContainer: {
    gap: 4,
  },
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 2,
  },
  detailLabel: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
  },
  detailValue: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 2,
    marginTop: 16,
  },
  totalLabel: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
  },
  totalValue: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
  },
});

export default PaymentDetailsSummary;
